import { Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from 'react-hook-form';
import Input from '@/components/Common/Input';
import Select from '@/components/Common/Select';
import TelInput from '@/components/Common/TelInput';
import { useGetPublicCountries, useGetPublicStates } from '@/apis/agency/businessOnboarding/hooks';
import { ScrollToTop } from '@/App';

export default function BusinessDetailsForm() {
  const { control, watch } = useFormContext();
  const countryCode = watch('address.country');

  const { data: countries, isLoading: isCountriesLoading } = useGetPublicCountries();
  const { data: states, isLoading: isStatesLoading } = useGetPublicStates(countryCode || '');

  return (
    <>
      <ScrollToTop state={1} />
      <Paper
        elevation={0}
        sx={{
          border: '1px solid #EAEAEA',
          borderRadius: 2,
          p: { xs: 2, md: 4 }
        }}
      >
        <Typography fontWeight={500} fontSize={20} mb={0.5}>
          Business Details
        </Typography>

        <Typography variant='body2' color='text.secondary' mb={3}>
          Add your business and primary contact information.
        </Typography>

        <Grid container spacing={3}>
          <Grid size={12}>
            <Input name='business_legal_name' label='Business Legal Name' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Input name='website_url' label='Website URL' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Input name='primary_contact_name' label='Primary Contact Person' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Input
              name='primary_contact_email'
              label='Primary Contact Email'
              control={control}
              disabled
              required
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TelInput
              name='primary_contact_phone'
              label='Primary Contact Phone'
              control={control}
              required
              disabled
              defaultCountry='US'
              fullWidth
            />
          </Grid>
        </Grid>

        <Typography fontWeight={500} fontSize={18} mt={5} mb={3}>
          Billing Address
        </Typography>

        <Grid container spacing={3}>
          <Grid size={12}>
            <Input name='address.street_address' label='Street Address' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Input name='address.city' label='City' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Input name='address.postal_zip_code' label='Postal / ZIP Code' control={control} required fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Select
              name='address.state_province_region'
              label='State / Province / Region'
              control={control}
              required
              fullWidth
              isLoading={isStatesLoading}
              options={states || []}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Select
              name='address.country'
              label='Country'
              control={control}
              required
              fullWidth
              isLoading={isCountriesLoading}
              options={countries || []}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
